/**
 * Produktion erfassen (R127): Zugänge on demand gedruckter Module von Butz & Bürker (Rolle `produktion`).
 *
 * Die Rolle sieht nur die freigegebenen Artikel (SKU, Name, Variante, Kategorie, Bild), nie Bestände, Preise oder
 * Kunden, und nur ihre eigenen Buchungen der letzten 30 Tage. Leitung/Admin sehen alle Buchungen und den Hinweis zum
 * Shop-Bestand.
 */

/** Ein für die Produktion freigegebener Artikel (Flag `on_demand_druck`). Bewusst ohne Bestand und Preis. */
export interface ProduktionsArtikel {
  id: string;
  sku: string;
  name: string;
  variante: string | null;
  kategorie: string | null;
  bild_url: string | null;
}

export interface ProduktionsArtikelListe {
  artikel: ProduktionsArtikel[];
  /** Nur für Leitung/Admin gesetzt: Hinweis, ob und wie der Shop-Bestand nach einer Buchung erhöht wird. */
  shop_hinweis: string | null;
}

export interface ProduktionsBuchungPosition {
  id: string;
  article_id: string;
  sku: string;
  name: string;
  variante: string | null;
  menge: number;
}

export interface ProduktionsBuchung {
  id: string;
  created_at: Date;
  benutzer: string | null;
  bemerkung: string | null;
  summe: number;
  positionen: ProduktionsBuchungPosition[];
  storniert_at: Date | null;
  storno_grund: string | null;
  /** Darf der Anfragende diese Buchung jetzt noch stornieren (eigene bzw. Leitung, nicht storniert, jünger als 24 h)? */
  stornierbar: boolean;
}

export interface ProduktionsBuchungErgebnis {
  buchung: ProduktionsBuchung;
  /** Anzahl wartender Sendungen, die der Zugang bedient hat (ohne Bestellnummern: die Rolle sieht keine Kunden). */
  bedient: number;
}

/** Storno nur binnen dieser Frist (Stunden), danach Korrekturbuchung durch die Leitung. */
export const PRODUKTION_STORNO_STUNDEN = 24;
/** „Meine Buchungen“ reicht so weit zurück (Tage). */
export const PRODUKTION_LISTE_TAGE = 30;
/** Obergrenze je Position (Tippfehler wie 2000 statt 20 abfangen). */
export const PRODUKTION_MAX_MENGE = 5000;
/** Bemerkung, die jede Produktionsbuchung im Journal trägt. */
export const PRODUKTION_BEMERKUNG = 'Produktion B&B';
